import React, { useState } from "react";
import { Box, Button, Modal, Typography, Stack } from "@mui/material";
import Status from "../../../../../common/enums/Status";

interface ActionConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (status: Status.ACTIVE | Status.IN_ACTIVE) => void; 
  title?: string;
  message?: string;
  selectedCount?: number;
  forcedAction?: "approve" | "reject";
  isSubmitting: "approve" | "reject" | null;
}

const TourApprovalConfirmationModal: React.FC<ActionConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to perform this action?",
  selectedCount,
  forcedAction,
  isSubmitting,
}) => {

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography variant="h6" mb={2}>
          {title}
        </Typography>
        <Typography mb={3}>
          {selectedCount
            ? `You have selected ${selectedCount} tour(s). Please choose an action.`
            : message}
        </Typography>

        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button variant="outlined" color="inherit" onClick={onClose} disabled={!!isSubmitting}>
            Cancel
          </Button>

          {/* Approve button */}
          {(forcedAction === "approve" || !forcedAction) && (
            <Button
              variant="contained"
              color="success"
              onClick={() => onConfirm(Status.ACTIVE)} // ✅ send active
              disabled={!!isSubmitting}
            >
              
            {isSubmitting === "approve" ? "Approving..." : "Approve"}
            </Button>
          )}

          {/* Reject button */}
          {(forcedAction === "reject" || !forcedAction) && (
            <Button
              variant="contained"
              color="error"
              onClick={() => onConfirm(Status.IN_ACTIVE)} // ✅ send inactive
              disabled={!!isSubmitting}
            >
                {isSubmitting === "reject" ? "Rejecting..." : "Reject"}
            </Button>
          )}
        </Stack>
      </Box>
    </Modal>
  );
};

export default TourApprovalConfirmationModal;
